import Text from "./Text";

export const ErrorMessage = ({
  message = "Something went wrong",
}: {
  message?: string;
}) => {
  return (
    <div>
      <Text className="text-red-500">Error: {message}</Text>
    </div>
  );
};

export const ErrorBoundaryFallback = ({
  error,
}: {
  error: Error | unknown;
  resetError?: () => void;
}) => {
  const message =
    error instanceof Error ? error.message : "Something went wrong";
  return <ErrorMessage message={message} />;
};
